import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-en/htdocs/en.nrgyblast.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-en/htdocs/en.nrgyblast.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-en/htdocs/en.nrgyblast.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/nrgyblast-en/htdocs/en.nrgyblast.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/nrgyblast-en/htdocs/en.nrgyblast.co/node_modules/next/dist/client/image-component.js");
